<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">Informes de Cobranzas</h4>
            <div class="small text-muted">Administración de todos los informes de cobranzas</div>
          </b-col>

          <b-col sm="5">
            <b-button @click="add()" type="button" variant="primary" size="sm" class="btn-pill float-right ml-2" v-b-tooltip.hover title="Agregar Informe">
              <i class="fa fa-plus"></i> Agregar
            </b-button>

            <b-col sm="12" class="d-none d-md-block" v-if="!table.mostrarFiltros">
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" @click="table.mostrarFiltros=true" v-b-tooltip.hover title="Mostrar filtros">
                <i class="fa fa-filter"></i> Mostrar Filtros
              </b-button>
            </b-col>
            <b-col sm="12" class="d-none d-md-block" v-else>
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" v-if="table.mostrarFiltros" @click="table.mostrarFiltros=false" v-b-tooltip.hover title="Ocultar filtros">
                <i class="fa fa-window-close"></i>
              </b-button>
            </b-col>
          </b-col>          
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row v-if="table.mostrarFiltros">
          <b-col sm="2">
            <b-row>
              <b-col md="6" class="pr-0">
                <b-form-input type="date" size="md" v-model="filter.date_start" placeholder="Fecha Desde"></b-form-input>
              </b-col>
              <b-col md="6" class="pl-0">
                <b-form-input type="date" size="md" v-model="filter.date_end" placeholder="Fecha Hasta"></b-form-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="7">
            <b-row>
              <b-col sm="2">
                <v-select :options="arr.filter.staff" v-model="filter.staff" placeholder="Staff" :multiple="true" :select-on-tab="true"></v-select>
              </b-col>        
              <b-col sm="2">
                <v-select :options="arr.filter.sellers" v-model="filter.sellers" placeholder="Vendedores" :multiple="true" :select-on-tab="true"></v-select>
              </b-col>       
              <b-col sm="2">
                <v-select :options="arr.filter.customers" v-model="filter.customers" placeholder="Clientes" :multiple="true" :select-on-tab="true"></v-select>
              </b-col>       
              <b-col sm="2">
                <v-select :options="arr.filter.read" v-model="filter.read" placeholder="Leido" :multiple="false" :select-on-tab="true"></v-select>                
              </b-col>      
              <b-col sm="2">
                <v-select :options="arr.filter.informed" v-model="filter.informed" placeholder="Promob" :multiple="false" :select-on-tab="true"></v-select>                
              </b-col>             
            </b-row>
          </b-col>      
          <b-col sm="2">
            <b-row>
              <b-col sm="6">
                <b-button variant="outline-dark" @click="filterReport()">
                  <b-icon icon="filter" class="mr-1" style="font-size:15px;"></b-icon>              
                  Filtrar
                </b-button>
              </b-col>                                     
              <b-col sm="6">
                <b-link>
                  <export-excel
                    class = 'pull-right mt-3'
                    :data = "arr.export"
                    worksheet = "Informe de Cobranzas"
                    name = "reports-payment.xls">
                    Exportar Datos
                  </export-excel>            
                </b-link>
              </b-col>    
            </b-row>
          </b-col>                  
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <b-table class="mb-0"
                    ref="table"
                    responsive="sm"
                    head-variant="dark"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="formartedItems"
                    :fields="table.fields"                    
                    :tbody-tr-class="rowClass"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    :busy="table.isBusy"     
                    v-if="table.items.length || table.isBusy">

                <template v-slot:table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando...</strong>
                  </div>
                </template>

                <template v-slot:cell(id)="data">
                  <b>{{ data.item.id }}</b>
                </template>

                <template v-slot:cell(date)="data">
                  {{ moment(data.item.date).format('DD MMMM YYYY') }}
                </template>

                <template v-slot:cell(responsable)="data">
                  <div v-if="data.item.staff_id">
                    <b-avatar :src="data.item.staff.image"
                              v-if="data.item.staff.image">
                    </b-avatar>
                    <b-avatar v-else                                                                         
                              variant="dark">
                    </b-avatar>                         
                    <b-icon icon="blank"></b-icon>
                    <b :title="'STAFF: ' + data.item.staff.name">
                      {{data.item.staff.name}}
                    </b>                                          
                  </div>
                  <div v-else>                    
                    <b-avatar :src="data.item.seller.staff.image"
                              v-if="data.item.seller.staff.image">
                    </b-avatar>
                    <b-avatar v-else                                                                         
                              variant="dark">
                    </b-avatar>     
                    <b-icon icon="blank"></b-icon>
                    <b :title="'VENDEDOR: ' + data.item.seller.staff.name">
                      {{data.item.seller.staff.name}}
                    </b>  
                  </div>                  
                </template>

                <template v-slot:cell(customers)="data">     
                  <div v-if="data.item.customers_id">             
                    <b-avatar :src="data.item.customer.image"
                              v-if="data.item.customer.image">
                    </b-avatar>
                    <b-avatar v-else 
                              icon="building"                                            
                              variant="dark">
                    </b-avatar>     
                    &nbsp;<b>{{data.item.customer.name}}</b>      
                    <b-icon icon="circle-fill" v-if="!data.item.customer.active" class="ml-2" variant="danger" v-b-tooltip.hover title="Cliente INACTIVO" />                           
                  </div>
                </template>

                <template v-slot:cell(read)="data">
                  <b-icon icon="toggle-on"  @click="checkRead(data.item)" class="h4 report-payment-check-read-table" v-if="!data.item.read" v-b-tooltip.hover title="Sin Leer"></b-icon>
                  <b-icon icon="toggle-off" class="h4" v-else v-b-tooltip.hover title="Leido"></b-icon>
                </template>

                <template v-slot:cell(informed)="data">
                  <b-icon icon="toggle-on"  @click="checkInformed(data.item)" class="h4 report-payment-check-read-table" v-if="!data.item.informed" v-b-tooltip.hover title="Sin Pasar"></b-icon>
                  <b-icon icon="toggle-off" class="h4" v-else v-b-tooltip.hover title="Pasado"></b-icon>
                </template>

                <template v-slot:cell(status)="row">
                  <div class="text-center" v-if="row.item.surrender_detail">
                    <b-badge v-if="row.item.surrender_detail.status=='Enviado'" variant="info" class="report-payment-surrender-badge">
                      {{row.item.surrender_detail.status}}
                    </b-badge>

                    <b-badge v-if="row.item.surrender_detail.status=='En Revisión'" variant="warning" class="report-payment-surrender-badge">
                      {{row.item.surrender_detail.status}}
                    </b-badge>

                    <b-badge v-if="row.item.surrender_detail.status=='Aprobado'" variant="success" class="report-payment-surrender-badge">
                      {{row.item.surrender_detail.status}}
                    </b-badge>
                    
                    <b-badge v-if="row.item.surrender_detail.status=='Rechazado'" variant="danger" class="report-payment-surrender-badge">
                      {{row.item.surrender_detail.status}}
                    </b-badge>

                    <b-badge v-if="row.item.surrender_detail.status=='No Recibido'" variant="secondary" class="report-payment-surrender-badge">
                      {{row.item.surrender_detail.status}}
                    </b-badge>
                  </div>
                </template>                

                <template v-slot:cell(amounts_items)="data">
                  <b>$ {{ data.item.amounts_items }}</b>
                </template>                

                <template v-slot:cell(observations)="data">
                  <div v-if="data.item.canceled" class="mb-2">
                    <b-badge variant="danger" class="reports-payment-canceled-badge"
                             v-b-tooltip.hover :title="data.item.reasons_canceled || 'Sin motivo registrado'">
                      Anulado
                    </b-badge>
                    <div class="small text-muted" v-if="data.item.reasons_canceled">
                      {{ truncateReason(data.item.reasons_canceled) }}
                    </div>
                  </div>
                  <div v-if="data.item.observations">
                    <div v-if="data.item.observations.length >50" :title="data.item.observations">
                      {{data.item.observations.substr(0, 50)}}
                    </div>
                    <div v-else>
                      {{data.item.observations}}
                    </div>
                  </div>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right text="Acción" size="sm" variant="outline-dark" class="pull-right">

                    <b-dropdown-item @click="irDetail(data.item)">
                      <b-icon icon="card-text"></b-icon> Detalle
                    </b-dropdown-item>       

                    <b-dropdown-item @click="checkRead(data.item)" v-if="!data.item.read">
                      <b-icon icon="eye-fill"></b-icon> Marcar como leido
                    </b-dropdown-item>       
                    <b-dropdown-item @click="checkNotRead(data.item)" v-if="data.item.read">
                      <b-icon icon="eye-slash-fill"></b-icon> Marcar como no leido
                    </b-dropdown-item>      

                    <b-dropdown-item @click="checkInformed(data.item)" v-if="!data.item.informed">
                      <b-icon icon="eye-fill"></b-icon> Marcar como informado
                    </b-dropdown-item>       
                    <b-dropdown-item @click="checkNotInformed(data.item)" v-if="data.item.informed">
                      <b-icon icon="eye-slash-fill"></b-icon> Marcar como no informado
                    </b-dropdown-item>                      

                    <b-dropdown-item @click="sendPrinterOrder(data.item)">
                      <b-icon icon="printer"></b-icon> Imprimir
                    </b-dropdown-item>    

                    <b-dropdown-item @click="openCancelModal(data.item)" v-if="canAnnulReport(data.item)">
                      <b-icon icon="x-circle"></b-icon> Anular
                    </b-dropdown-item>

                    <b-dropdown-item @click="restoreReport(data.item)" v-if="canRestoreReport(data.item)">
                      <b-icon icon="arrow-counterclockwise"></b-icon> Restaurar
                    </b-dropdown-item>

                    <b-dropdown-header>Acciones</b-dropdown-header>
                    <b-dropdown-item @click="remove(data.item)" v-if="access.elements.deleteReport">
                      <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>                        
          </b-col>

          <b-col>            
            <nav v-if="table.tablePaginate">
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="table.tablePaginate.total"
                            :per-page="table.tablePaginate.per_page"
                            v-model="table.currentPage" 
                            @input="filterReport()" />
            </nav>    
          </b-col>          
        </b-row>
      </b-card>

      <!--
      ###########################
      ######### PRINTER #########
      ###########################
      -->
      <Printer v-if="crud.print.id" 
              :reference="crud.print.reference" 
              :registerID="crud.print.id"
              :key="crud.print.key"/>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              header-bg-variant="dark"
              header-text-variant="white"
              no-close-on-esc
              no-close-on-backdrop              
              size="xl">
        <div slot="modal-header">
          {{this.modal.form.title}}
        </div>

        <b-row>      
          <b-col md="6">
            <b-form-group label="Fecha">
              <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es"></b-form-datepicker>                      
            </b-form-group>            
          </b-col>

          <b-col md="6">
            <FindObject render="search"
                        type="customers" 
                        @select-object="loadCustomers($event)" 
                        :valueID="crud.form.customers_id"/>                 
          </b-col>    
        </b-row>
        
        <form-wizard v-if="crud.form.customers_id"
                      title=""
                      subtitle=""
                      nextButtonText="Siguiente"
                      backButtonText="Atrás"
                      finishButtonText="Guardar"
                      color="#2f353a"
                      shape="tab"
                      @on-complete="save">

          <tab-content title="Comprobantes" icon="icon-docs">          
            <b-row>
              <b-col lg="12" md="12" sm="12">
                <b-card>  
                  <div slot="header" class="p-0">
                    <i class="icon-docs"></i><strong> Que cancela</strong>
                    <span class="balance-pending">
                      <b>Saldo Pendiente: </b> <span style="color: red;">$ {{this.total.vouchersBalancePending}}</span>
                    </span>                  
                  </div>

                  <b-row class="mb-3">
                    <b-col cols="12" md="6">
                      <b-form-group label="Tipo de comprobante">
                        <b-form-radio-group
                          v-model="crud.form.voucher_type"
                          :options="arr.select.voucherTypes"
                          buttons
                          button-variant="outline-dark"
                          size="sm"
                          :disabled="!crud.form.customers"
                          @change="onVoucherTypeChange"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-alert v-if="!crud.form.voucher_type" show variant="info">
                    Seleccioná si vas a trabajar con comprobantes D o ND.
                  </b-alert>

                  <b-row>
                    <b-col cols="12">
                      <b-table-simple hover small caption-top responsive v-if="arr.select.vouchersPending.length" class="crud-receipts-table-items">
                        <b-thead head-variant="dark">
                            <b-tr>
                                <b-th class="text-left" width="8%">Seleccionar</b-th>
                                <b-th class="text-left" width="12%">Fecha</b-th>
                                <b-th class="text-left" width="21%">Comprobante</b-th>
                                <b-th class="text-left" width="5%"></b-th>
                                <b-th v-for="n in 4" :key="'head'+n" class="text-right">% Desc. {{ n }}</b-th>
                                <b-th class="text-right" width="12%">$ Desc. Total</b-th>
                                <b-th class="text-right" width="12%">Importe</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item, index) in arr.select.vouchersPending" :key="item.id">
                                <b-td>
                                    <b-form-checkbox 
                                        v-model="crud.formPending[index].check"
                                        @change="checked => onVoucherCheckChange(index, checked)"
                                        switch size="sm"
                                    ></b-form-checkbox>
                                </b-td>

                                <b-td>{{ moment(item.date).format('DD/MM/YYYY') }}</b-td>

                                <b-td>{{ item.text }}</b-td>

                                <b-td>
                                    <b-link v-if="crud.formPending[index].check && !isAnticipoVoucher(index) && !isNotaCreditoVoucher(index)" @click="showDetailVoucher(item, index)">
                                        <b-icon icon="plus" />
                                    </b-link>
                                </b-td>

                                <b-td v-for="n in 4" :key="'disc'+n" class="text-right align-middle">
                                    <b-form-input
                                        v-if="crud.formPending[index].check"
                                        v-model.number="crud.formPending[index]['discount' + n]"
                                        type="number"
                                        min="0"
                                        max="100"
                                        step="0.01"
                                        size="sm"
                                        :disabled="isAnticipoVoucher(index) || isNotaCreditoVoucher(index)"
                                        @input="() => onRowDiscountChange(index, n)"
                                    />
                                </b-td>

                                <b-td class="text-right align-middle">
                                    <span>{{ crud.formPending[index].amount_discount }}</span>
                                </b-td>

                              <b-td class="text-right align-middle">
                                <div v-if="crud.formPending[index].check && (isAnticipoVoucher(index) || isNotaCreditoVoucher(index))">
                                    <div class="small text-muted mb-1" v-if="crud.formPending[index].amount != item.amount">
                                        Original: $ {{ parseFloat(item.amount).toFixed(2) }}
                                    </div>
                                    
                                    <b-input-group size="sm">
                                        <b-form-input
                                            v-model.number="crud.formPending[index].amount"
                                            type="number"
                                            size="sm"
                                            :max="Math.abs(item.amount)"
                                            @change="validateAnticipoAmount(index, item.amount)"
                                        />
                                    </b-input-group>
                                </div>
                                <span v-else>
                                    $ {{ parseFloat(item.amount).toFixed(2) }}
                                </span>
                              </b-td>
                            </b-tr>
                        </b-tbody>
                      </b-table-simple>

                      <b-alert v-else-if="crud.form.voucher_type" show variant="warning">
                        No hay comprobantes para imputar.
                      </b-alert>
                    </b-col>
                  </b-row>

                  <hr>
                  
                  <!-- Descuentos generales -->
                  <b-row class="align-items-end">
                    <b-col v-for="n in 4" :key="'gen'+n" cols="4" md="3" lg="2">
                      <b-form-group :label="`% Descuento ${n}`">
                        <b-input-group size="sm">
                          <b-form-input
                            v-model.number="crud.form['discount' + n]"
                            type="number"
                            min="0"
                            max="100"
                            step="0.01"
                            placeholder="0"
                            @input="onGeneralDiscountChange(n)"
                          />
                          <b-input-group-append>
                            <span class="input-group-text">%</span>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <!-- Total final con descuento -->
                    <b-col cols="8" md="5" lg="4">
                      <div class="report-payment-label report-payment-total-size">
                        TOTAL: $ {{ totalVouchers }}
                      </div>
                    </b-col>
                  </b-row>


                </b-card>          
              </b-col>
            </b-row>
          </tab-content>
          <tab-content title="Pago" icon="fa fa-money">          
            <b-row>
              <b-col lg="12" md="12" sm="12">
                <b-card>  
                  <div slot="header">
                    <i class="fa fa-money"></i><strong> Desglose de Pago</strong>
                  </div>

                  <b-row>
                    <b-col lg="3" md="3">            
                      <b-form-group label="Medio">                  
                        <b-form-select v-model="crud.form.detail_register.type" :options="arr.select.type"></b-form-select>                    
                      </b-form-group>
                    </b-col>                     
                    <b-col lg="2" md="2" v-if="crud.form.detail_register.type != 'cheque' && crud.form.detail_register.type != 'ajustes varios'">
                      <b-form-group label="Fecha"> 
                        <input v-model="crud.form.detail_register.date" type="date" class="form-control" />
                      </b-form-group>
                    </b-col>                
                    <b-col lg="2" md="2" v-if="crud.form.detail_register.type == 'ret iibb'">
                      <b-form-group label="Nro. Constancia"> 
                        <input v-model="crud.form.detail_register.nro_certificate" type="text" class="form-control" />
                      </b-form-group>
                    </b-col>
                    <b-col lg="3" md="3">
                      <b-form-group label="Importe"> 
                        <b-input-group prepend="$">
                          <input v-model="crud.form.detail_register.amount" type="number" min="0" step="0.01" class="form-control"/>                      
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col lg="2" md="2">
                      <b-button class="report-payment-button-add" @click="addItem(false)" v-b-tooltip.hover title="Agregar Item">
                        <i class="fa fa-plus"></i>
                      </b-button>                              
                      <b-button class="report-payment-button-check" @click="openCheck()" v-if="crud.form.detail_register.type == 'cheque'" v-b-tooltip.hover title="Ver datos del cheque">
                        <i class="fa fa-credit-card-alt"></i>
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col lg="6" md="6">
                      <b-form-group label="Adjuntar comprobante">
                        <b-form-file
                          ref="detailAttachmentInput"
                          v-model="crud.form.detail_register.attachment_file"
                          browse-text="Adjuntar"
                          size="sm"
                          :state="Boolean(crud.form.detail_register.attachment || crud.form.detail_register.attachment_file)"
                          placeholder="Elegí un archivo o soltarlo aquí"
                          drop-placeholder="Suelta el archivo aquí"
                          @input="onDetailAttachmentInput"
                        />
                        <div v-if="crud.form.detail_register.attachment_name" class="mt-2">
                          <b-badge variant="info">{{ crud.form.detail_register.attachment_name }}</b-badge>
                          <b-button
                            size="sm"
                            variant="outline-danger"
                            class="ml-2"
                            @click="clearDetailAttachment"
                          >
                            Quitar
                          </b-button>
                          <div class="text-muted small mt-1">
                            El archivo se guardará cuando confirmes el reporte.
                          </div>
                        </div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>                  
                      <b-table class="mb-0"
                        responsive="sm"
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :items="crud.form.detail"
                        :fields="table_payment">
                                                                
                        <template v-slot:cell(type)="data">
                          <div>{{ data.item.type.toUpperCase() }}</div>
                        </template>
                        
                        <template v-slot:cell(check)="data">  
                          <div v-if="data.item.type=='cheque'">
                            <div :id="'popover-target-' + data.index" class="badge badge-secondary text-wrap report-payment-popover-size">
                              Más Info Cheque
                            </div>
                            <b-popover :target="'popover-target-' + data.index" title="Info Cheque" triggers="hover" placement="top">                      
                              <table>
                                <tr>
                                  <td class="report-payment-popover-item-header">Tipo</td>
                                  <td>{{data.item.check.type.toUpperCase()}}</td>
                                </tr>                            
                                <tr>
                                  <td class="report-payment-popover-item-header">Banco</td>
                                  <td>{{data.item.check.bank}}</td>
                                </tr>
                                <tr>
                                  <td class="report-payment-popover-item-header">Número</td>
                                  <td>{{data.item.check.number}}</td>
                                </tr> 
                                <tr>
                                  <td class="report-payment-popover-item-header">Fecha</td>
                                  <td>
                                    <div v-if="data.item.check.date_movement">
                                      {{moment(data.item.check.date_movement).format('DD/MM/YYYY')}}
                                    </div>
                                  </td>
                                </tr>                        
                                <tr>
                                  <td class="report-payment-popover-item-header">CUIT</td>
                                  <td>{{data.item.check.cuit}}</td>
                                </tr>
                                <tr>
                                  <td class="report-payment-popover-item-header">Observaciones</td>
                                  <td>{{data.item.check.observations}}</td>
                                </tr>                                                                            
                              </table>
                            </b-popover>                    
                          </div>
                        </template>
                        <template v-slot:cell(attachment)="data">
                          <div v-if="data.item.attachment">
                            <div v-if="isStoredAttachment(data.item.attachment)">
                              <b-link
                                :href="getAttachmentUrl(data.item.attachment)"
                                target="_blank"
                                rel="noopener"
                              >
                                Ver archivo
                              </b-link>
                            </div>
                            <div v-else>
                              <b-badge variant="secondary">Adjunto pendiente</b-badge>
                              <div class="text-muted small">
                                {{ data.item.attachment_name || 'Se guardará al confirmar' }}
                              </div>
                            </div>
                          </div>
                          <span v-else class="text-muted">Sin archivo</span>
                        </template>
                        
                        <template v-slot:cell(amount)="data">  
                          <div class="report-payment-text-green">
                            $ {{ parseFloat(data.item.amount).toFixed(2) }}
                          </div>
                        </template>                  
                                                                
                        <template v-slot:cell(f_action)="data">  
                          <b-dropdown right text="Acción" size="sm" variant="outline-dark">                      
                            <b-dropdown-item @click="editItem(data.item, data.index)">
                              <i class="fa fa-pencil ml-0 mr-0" style="color:blue"></i> Editar
                            </b-dropdown-item>
                            <b-dropdown-item
                              v-if="data.item.attachment"
                              @click="clearAttachmentFromDetail(data.index)"
                            >
                              <i class="fa fa-paperclip ml-0 mr-0"></i> Quitar adjunto
                            </b-dropdown-item>
                            <b-dropdown-item @click="deleteItem(data.index)" style="color:red;">
                              <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
                            </b-dropdown-item>     
                          </b-dropdown>                                
                        </template>                    
                      </b-table>                  
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row>
                    <b-col>
                      <div class="report-payment-label report-payment-total-size">
                        TOTAL: $ {{ totalPayment }}
                      </div>   
                    </b-col>
                    <b-col>                  
                      <div class="report-payment-label report-payment-total-size report-payment-diff-lack" v-if="diffPayment<0">
                        FALTAN: $ {{ diffPayment }}
                      </div> 
                      <div class="report-payment-label report-payment-total-size report-payment-diff-surplus" v-if="diffPayment>0">
                        SOBRAN: $ {{ diffPayment }}
                      </div> 
                      <div v-if="totalPayment>0">
                        <div class="report-payment-label report-payment-total-size report-payment-diff-just" v-if="diffPayment==0">
                          JUSTO
                        </div>
                      </div>               
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>        
            </b-row>
          </tab-content>
          <tab-content title="Observaciones" icon="fa fa-flag-checkered">          
            <b-row>
              <b-col md="12">
                <b-form-group label="Observaciones">
                  <b-form-textarea                
                    v-model="crud.form.observations"
                    placeholder="Ingresar las observaciones..."
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>         
            </b-row>
          </tab-content>

        </form-wizard>
        
        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>              
        </div>
      </b-modal>
      
      <!-- CRUD CHEQUE -->      
      <b-modal v-model="modal.check.active"
              centered
              header-bg-variant="dark"
              header-text-variant="white"
              no-close-on-esc
              no-close-on-backdrop               
              size="md">
        <div slot="modal-header">
          {{this.modal.check.title}}
        </div>

        <b-row>
          <b-col md="4">            
            <b-form-group label="Tipo">
              <b-form-select v-model="crud.form.detail_register.check.type" :options="arr.select.check"></b-form-select>
            </b-form-group>
          </b-col>            
          <b-col md="4">
            <b-form-group label="Banco">            
              <b-form-input v-model="crud.form.detail_register.check.bank" type="text" size="md"></b-form-input>            
            </b-form-group>
          </b-col>       
          <b-col md="4">
            <b-form-group label="Número Cheque">            
              <b-form-input v-model="crud.form.detail_register.check.number" type="text" size="md"></b-form-input>            
            </b-form-group>
          </b-col> 
          <b-col md="6">
            <b-form-group label="Fecha de Pago">            
              <b-form-input v-model="crud.form.detail_register.check.date_movement" type="date" size="md"></b-form-input>            
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="CUIT Emisor">            
              <b-form-input v-model="crud.form.detail_register.check.cuit" type="text" size="md"></b-form-input>                 
              <a class="verify-credit-status" @click="verifyBCRA()">
                    Verifique la situación crediticia antes de continuar.
                  <i class="cui-chevron-right"></i><i class="cui-chevron-right"></i>
              </a>              
            </b-form-group>
          </b-col>      
          <b-col md="12">
            <b-form-group label="Observaciones (opcional)">            
              <b-form-input v-model="crud.form.detail_register.check.observations" type="text" size="md"></b-form-input>            
            </b-form-group>
          </b-col>                         
        </b-row>                 

        <div slot="modal-footer">
          <b-button size="sm" variant="outline-secondary" class="mr-1" @click="modal.check.active=false">Cancelar</b-button>
          <b-button size="sm" variant="secondary" @click="addItem(true)">Guardar</b-button>
        </div>
      </b-modal>

      <!-- CRUD VOUCHER AMOUNT -->    
      <b-modal v-model="modal.vouchers.active"
              centered
              header-bg-variant="dark"
              header-text-variant="white"              
              no-close-on-esc
              no-close-on-backdrop               
              size="sm">
        <div slot="modal-header">
          {{this.modal.vouchers.title}}
        </div>
        
        <b-row>
          <b-col md="12">
            <b-form-group label="Fecha">            
              <b-form-input v-model="crud.form.vouchers_edit.date" type="text" readonly size="sm"></b-form-input>            
            </b-form-group>
          </b-col>  

          <b-col md="12">
            <b-form-group label="Comprobante">            
              <b-form-input v-model="crud.form.vouchers_edit.vouchers" type="text" readonly size="sm"></b-form-input>            
            </b-form-group>
          </b-col>  

          <b-col md="12">
            <b-form-group label="Importe">
              <b-input-group prepend="$" size="md">            
                <b-form-input v-model="crud.form.vouchers_edit.amount" type="number" setp="0.01" min="0.00"></b-form-input>            
              </b-input-group>
            </b-form-group>
          </b-col>  
        </b-row>        

        <div slot="modal-footer">          
          <b-button size="sm" variant="outline-secondary" class="mr-1" @click="modal.vouchers.active=false">Cancelar</b-button>
          <b-button size="sm" class="secondary" @click="vouchersEditSave(crud.form.vouchers_edit)">Guardar</b-button>          
        </div>
      </b-modal>   

      <!-- DETAIL VOUCHER -->    
      <b-modal v-model="modal.detailVoucher.active"
              centered
              header-bg-variant="dark"
              header-text-variant="white"              
              no-close-on-esc
              no-close-on-backdrop               
              size="lg">
        <div slot="modal-header">
          {{this.modal.detailVoucher.title}}
        </div>

        <b-row v-if="arr.select.vouchersPending.length && arr.select.vouchersPending[modal.detailVoucher.index].detail.length">
          <b-col md="12">
            <b-table-simple hover small caption-top responsive class="crud-receipts-table-items">
              <b-thead head-variant="dark">
                <b-tr>
                  <b-th class="text-left" width="30%">Producto</b-th>
                  <b-th class="text-left" width="6%">Cantidad</b-th>                  
                  <b-th v-for="n in 4" :key="'head'+n" class="text-right">% Desc. {{ n }}</b-th>
                  <b-th class="text-left" width="17%">Importes</b-th>
                  <b-th class="text-left" width="10%">Total</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr 
                  v-for="(item, index) in arr.select.vouchersPending[modal.detailVoucher.index].detail" 
                  :key="item.id"
                >                  
                  <b-td>{{ item.description }}</b-td>
                  <b-td>{{ item.quantity }}</b-td>
                  
                  <!-- 4 descuentos -->
                  <b-td 
                    v-for="n in 4" 
                    :key="'disc'+n" 
                    class="text-right align-middle"
                  >
                    <b-form-input
                      v-model.number="crud.formPending[modal.detailVoucher.index].detail[index]['discount' + n]"
                      type="number"
                      min="0"
                      max="100"
                      step="0.01"
                      size="sm"
                      @input="onDetailDiscountChange(modal.detailVoucher.index, index, n)"
                    />

                  </b-td>

                  <b-td>
                    <b>Neto:</b> $ {{ parseFloat(item.amount_net).toFixed(2) }}<br>
                    <b>Prorrateo:</b> $ {{ parseFloat(item.amount_apportionment).toFixed(2) }}
                  </b-td>
                  <b-td>
                    $ {{ parseFloat(item.amount).toFixed(2) }}
                  </b-td>
                </b-tr>

              </b-tbody>
            </b-table-simple>
          </b-col>  
        </b-row>        

        <div slot="modal-footer">          
          <b-button size="sm" variant="outline-secondary" class="mr-1" @click="modal.detailVoucher.active=false">Cancelar</b-button>
          <b-button size="sm" class="secondary" @click="closeDetailVoucher()">Listo</b-button>          
        </div>
      </b-modal>            

      <b-modal v-model="modal.cancel.active"
               header-bg-variant="dark"
               header-text-variant="white"
               no-close-on-backdrop
               no-close-on-esc>
        <template #modal-title>
          Anular informe {{ modal.cancel.item ? ('#' + modal.cancel.item.id) : '' }}
        </template>

        <b-form-group label="Motivo de anulación">
          <b-form-textarea
            v-model="modal.cancel.reason"
            rows="3"
            max-rows="6"
            placeholder="Describí brevemente el motivo"
            :state="modal.cancel.reason.length > 0"
          />
        </b-form-group>

        <b-alert variant="warning" show class="mb-0">
          Esta acción no elimina el informe, solo lo marca como anulado y lo resaltará en rojo para todo el equipo.
        </b-alert>

        <template #modal-footer>
          <b-button size="sm" variant="outline-secondary" @click="closeCancelModal">Cancelar</b-button>
          <b-button size="sm" variant="danger" @click="submitCancel" :disabled="!modal.cancel.reason.trim()">Anular informe</b-button>
        </template>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import Funciones from '@/handler/funciones' 
  import moment from 'moment'
  import FindObject from '@/components/inc/find/findObject' 
  import Vue from 'vue'
  import excel from 'vue-excel-export'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import Storage from '@/handler/storageSession'
  import Printer from '@/components/inc/printer/printer'

  Vue.use(excel)

  export default {
    components: {
      FindObject,
      FormWizard,
      TabContent,
      Printer     
    }, 
    data: () => {
      return {      
        access: {
          module_id: Modules.INFORME_COBRANZAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudReport',
          elements: {            
            deleteReport: true             
          }
        }, 
        table : {
          items: [],
          fields: [
            {key: 'id', label: 'ID', sortable: true, class: "align-middle"},
            {key: 'date', label: 'Fecha', class: "align-middle"},
            {key: 'responsable', label: 'Responsable', class: "align-middle"},
            {key: 'customers', label: 'Cliente', class: "align-middle"},            
            {key: 'amounts_items', label: 'Total', class: "align-middle text-center"},
            {key: 'observations', label: 'Observaciones', class: "align-middle"},
            {key: 'status', label: 'Rendición', class: 'align-middle text-center'},
            {key: 'read', label: 'Estado', class: "align-middle text-center"},            
            {key: 'informed', label: 'Promob', class: "align-middle text-center"},            
            {key: 'f_action', label:'', class: "align-middle"},
          ],          
          mostrarFiltros: true,
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,      
        },
        table_vouchers : [
          {key: 'date', label: 'Fecha'},    
          {key: 'vouchers', label: 'Comprobante'},    
          {key: 'amount', label: 'Importe'},   
          {key: 'f_action', label:'Acción'}, 
        ],
        table_payment : [
          {key: 'type', label: 'Medio'},              
          {key: 'check', label: 'Info Extra'},    
          {key: 'nro_certificate', label: 'Nro. Constancia'},  
          {key: 'date', label: 'Fecha'},  
          {key: 'attachment', label: 'Adjunto'},
          {key: 'amount', label: 'Importe'},                
          {key: 'f_action', label:'Acción'},
        ],
        crud: {
          formPending: [],
          form: {
            id: 0,
            date: '',
            observations: '',            
            staff_id: 0,
            sellers_id: 0,
            customers_id: 0,
            customers: null,
            read: false,
            informed: false,  
            voucher_type: null,
            discount_1: 0,
            discount_2: 0,
            discount_3: 0,
            discount_4: 0,
            type_operation: '',
            vouchers_pending: [],
            vouchers_edit: {},                       
            vouchers_tmp: {            
              vouchers_id: null,            
            },                
            vouchers: [],

            detail_register: {
              type: 'efectivo',
              date: '',
              nro_certificate: '',
              amount_items: 0,              
              amount_vouchers: 0,              
              attachment: '',
              attachment_name: '',
              attachment_file: null,
              check: {              
                type: 'de_terceros',                
                bank: '',                  
                number: '',
                date_movement: '',
                cuit: '',
                observations: ''
              },    
            },
            detail: []                 
          },    
          print: {
            reference: 'reports-payment',
            id: 0,
            key: 0,
          }       
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
          vouchers: {
            active: false,
            title: ''            
          },          
          check: {
            active: false,
            title: ''
          },        
          detailVoucher: {
            active: false,
            title: '',
            index: 0,
          },
          cancel: {
            active: false,
            item: null,
            reason: ''
          }            
        },
        arr: {
          export: [],
          filter : {
            customers: [],
            staff: [],
            sellers: [],
            read: [
              {code:true, label: 'Leido'},
              {code:false, label: 'No Leidos'},                            
            ],         
            informed: [
              {code:true, label: 'Pasado'},
              {code:false, label: 'No Pasado'},                            
            ],        
          },
          select: {
            type: [
              { value: 'efectivo', text: 'EFECTIVO' },
              { value: 'cheque', text: 'CHEQUE' },
              { value: 'transferencia', text: 'TRANSFERENCIA' },
              { value: 'ret iibb', text: 'RET. IIBB' },
              { value: 'ret ganancia', text: 'RET. GANANCIA' },
              { value: 'ret iva', text: 'RET. IVA' },
              { value: 'ret suss', text: 'RET. SUSS' },
              { value: 'ajustes varios', text: 'AJUSTES VARIOS' },          
              { value: 'nota de débito', text: 'NOTA DE DEBITO' },    
            ],
            check: [
              { value: 'propios', text: 'PROPIOS' },
              { value: 'de_terceros', text: 'DE TERCEROS' },                            
            ],
            vouchersPending: [],
            voucherTypes: [
              { value: 'D', text: 'Comprobantes D' },
              { value: 'ND', text: 'Comprobantes ND' },
            ]        
          }
        },
        filter: {
          date_start: '',
          date_end: '',
          customers: [],
          staff: [],
          sellers: [],
          read: null,
          informed: null
        },
        total : {
          vouchersBalancePending: 0,
          vouchersBalancePendingValid: 0,
        },    
        customersID: 0,   
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      this.access.elements.deleteReport = Helper.hasAccessElement(this.access, 'delete_report')       
      /* Fin configuracion */
    },  
    mounted() {      
      this.customersID = this.$route.params.customersID
      if(this.customersID) {
        this.validCustomers()
      }

      if(this.isSeller) {
        this.$router.push({ name: 'ReportsPaymentStaffCrudReportSeller' })
      }

      this.filterLoad()
      this.filterReport()
    },
    computed: {
      formartedItems () {
        if (!this.table.items) return []
        return this.table.items.map(item => {
          if(!item.read){
            item._rowVariant  = 'active'
          }
          return item
        })
      },
      
      totalVouchers() {
        let total = 0;

        this.arr.select.vouchersPending.forEach((voucher, index) => {
          const formItem = this.crud.formPending[index];
          if (!formItem || !formItem.check) return;

          // Usar el importe modificado de crud.formPending si existe,
          // de lo contrario, usar el importe original del voucher.
          // Esto es especialmente importante para los anticipos.
          const voucherAmount = parseFloat(formItem.amount || voucher.amount);
          const isAnticipo = this.isAnticipoVoucher(index);

          if (formItem.detail && formItem.detail.length) {
            // Recorremos los detalles
            formItem.detail.forEach(item => {
              let amount = parseFloat(item.amount || 0);

              for (let n = 1; n <= 4; n++) {
                const discount = parseFloat(item['discount' + n] || 0);
                if (discount) {
                  amount = amount - amount * (discount / 100); // descuento acumulado
                }
              }
              const signedAmount = isAnticipo ? -Math.abs(amount) : amount;
              total += signedAmount;
            });
          } else {
            // Si no hay detalle, usamos el monto del voucher
            let amount = voucherAmount;

            for (let n = 1; n <= 4; n++) {
              const discount = parseFloat(formItem['discount' + n] || 0);
              if (discount) {
                amount = amount - amount * (discount / 100);
              }
            }
            const signedAmount = isAnticipo ? -Math.abs(amount) : amount;
            total += signedAmount;
          }
        });

        return total.toFixed(2);
      },

      totalPayment () {
        return this.crud.form.detail.reduce((sum, item) => {
          return sum + parseFloat(item.amount)                        
        }, 0).toFixed(2)
      },      
      diffPayment () {
        return (this.totalPayment - this.totalVouchers).toFixed(2)
      }, 
      isAdmin () {
        const currentSession = Session.getSession()
        return !!(currentSession && currentSession.auth && currentSession.auth.user && currentSession.auth.user.rol_admin)
      },
      isSeller(){
        if(Helper.getSeller()) {
          return true
        } else {
          return false
        }
      }                          
    },    
    methods: {
      rowClass(item, type) {
        if (type !== 'row' || !item) {
          return ''
        }
        return item.canceled ? 'reports-payment-row-canceled' : ''
      },
      truncateReason(text, max = 70) {
        if (!text) {
          return ''
        }
        const clean = text.trim()
        return clean.length > max ? `${clean.substr(0, max)}...` : clean
      },
      canAnnulReport(item) {
        return item && !item.canceled
      },
      canRestoreReport(item) {
        return item && item.canceled
      },
      openCancelModal(item) {
        this.modal.cancel.item = item
        this.modal.cancel.reason = ''
        this.modal.cancel.active = true
      },
      closeCancelModal() {
        this.modal.cancel.active = false
        this.modal.cancel.item = null
        this.modal.cancel.reason = ''
      },
      submitCancel() {
        const reason = this.modal.cancel.reason ? this.modal.cancel.reason.trim() : ''
        if (!reason) {
          this.$awn.alert('Ingresá un motivo para anular el informe')
          return
        }
        if (!this.modal.cancel.item) {
          return
        }

        const loader = this.$loading.show()
        serviceAPI.anular(this.modal.cancel.item.id, { reasons_canceled: reason, status: true })
          .then((response) => {
            const updated = response.data
            const index = this.table.items.findIndex(report => report.id === updated.id)
            if (index !== -1) {
              Vue.set(this.table.items, index, updated)
            }
            this.arr.export = []
            this.prepareExport(this.table.items)
            this.$awn.success('Informe anulado correctamente')
            this.closeCancelModal()
          })
          .catch(error => {
            this.$awn.alert(Error.showError(error))
          })
          .finally(() => {
            loader.hide()
          })
      },
      restoreReport(item) {
        if (!item || !item.canceled) {
          return
        }

        this.$bvModal.msgBoxConfirm('¿Querés restaurar el informe y quitar la marca de anulado?', {
          title: `Restaurar informe #${item.id}`,
          okVariant: 'success',
          okTitle: 'Restaurar',
          cancelTitle: 'Cancelar'
        }).then(value => {
          if (!value) {
            return
          }

          const loader = this.$loading.show()
          serviceAPI.anular(item.id, { status: false })
            .then((response) => {
              const updated = response.data
              const index = this.table.items.findIndex(report => report.id === updated.id)
              if (index !== -1) {
                Vue.set(this.table.items, index, updated)
              }
              this.arr.export = []
              this.prepareExport(this.table.items)
              this.$awn.success('Informe restaurado correctamente')
            })
            .catch(error => {
              this.$awn.alert(Error.showError(error))
            })
            .finally(() => {
              loader.hide()
            })
        })
      },
      validCustomers() {        
        this.add()                
        this.crud.form.customers_id = parseInt(this.customersID.slice(0, this.customersID.indexOf('|')))
      },
            
      // SALDOS Y COMPROBANTES PENDIENTES DE PROVEEDORES
      getVouchersPendingByCustomers() {
        this.crud.form.vouchers = []
        this.arr.select.vouchersPending = []
        this.crud.formPending = []

        if (!this.crud.form.customers || !this.crud.form.voucher_type) {
          return
        }

        let loader = this.$loading.show()

        serviceAPI.getVouchersPendingByCustomers({
          customers_code: this.crud.form.customers.code,
          voucher_type: this.crud.form.voucher_type,
        })
        .then((response) => {
          const vouchersPending = response.data
              
          vouchersPending.forEach((value) => {
            const text = value.vouchers || ((value.type_voucher && value.type_voucher.name ? value.type_voucher.name : 'Tipo') + ' ' + (value.point_sale && value.point_sale.point_sale ? value.point_sale.point_sale : '0000') + '-' + (value.number || '00000000'))

            this.arr.select.vouchersPending.push({
              id: value.id,
              text,
              date: value.date,
              amount: parseFloat(value.amount),
              type: value.type,
              detail: value.detail,
            })
            
            let arrDetail = value.detail.map(i => ({              
              ...i, 
              discount1: 0, 
              discount2: 0, 
              discount3: 0, 
              discount4: 0 
            }))            

            this.crud.formPending.push({
              id: value.id,
              check: false,
              amount: parseFloat(value.amount),
              discount1: 0,
              discount2: 0,
              discount3: 0,
              discount4: 0,
              discountEdited: false,
              detail: arrDetail,
            })
          })

          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        })
      },
      onVoucherTypeChange(value) {
        this.crud.form.voucher_type = value
        if (!value || !this.crud.form.customers) {
          this.getVouchersPendingByCustomers()
          return
        }
        this.getVouchersPendingByCustomers()
      },

      getBalancePendingByCustomers(value) {              
        if(value) {
          var result = serviceAPI.getBalancePendingByCustomers({
            customers_code: value.code
          })        

          result.then((response) => {          
            var data = response.data;          
            if(data.amount) {
              this.total.vouchersBalancePending = data.amount
            } else {
              this.total.vouchersBalancePending = 0
            }
          })
          .catch(error => {
            this.$awn.alert(Error.showError(error));    
          });      
        } else {
          this.total.vouchersBalancePending = 0        
        }
      },

      // ABM ITEMS
      async addItem (status_check) {
        if (!this.crud.form.detail_register.type) {
          this.$awn.alert('Falta seleccionar el medio de pago')          
          return false
        }

        if (!this.crud.form.detail_register.amount) {
          this.$awn.alert('Falta cargar el importe del pago')             
          return false
        }          

        if (this.crud.form.detail_register.type == 'cheque' && !this.checkOk()) {
          this.modal.check.active = true
          this.modal.check.title = "Datos del cheque"
          this.crud.form.detail_register.check.type = 'de_terceros'
          if (status_check) {
            this.$awn.alert('Falta cargar datos del cheque')
          }
          return false
        } 

        const type = this.crud.form.detail_register.type;

        let attachmentPayload = this.crud.form.detail_register.attachment || '';
        let attachmentName = this.crud.form.detail_register.attachment_name || '';
        const attachmentFileRaw = this.crud.form.detail_register.attachment_file;
        const attachmentFile = Array.isArray(attachmentFileRaw) ? attachmentFileRaw[0] : attachmentFileRaw;

        if (attachmentFile) {
          try {
            attachmentPayload = await this.fileToBase64(attachmentFile);
            attachmentName = attachmentFile.name;
          } catch (error) {
            this.$awn.alert('No se pudo leer el archivo seleccionado');
            this.clearDetailAttachment();
            return false;
          }
        }

        var arrItem = {
          type: type,
          nro_certificate: this.crud.form.detail_register.nro_certificate,
          amount: this.crud.form.detail_register.amount,
          attachment: attachmentPayload,
          attachment_name: attachmentName,
          check: {
            type: this.crud.form.detail_register.check.type,
            bank: this.crud.form.detail_register.check.bank,
            number: this.crud.form.detail_register.check.number,
            cuit: this.crud.form.detail_register.check.cuit,
            date_movement: this.crud.form.detail_register.check.date_movement,
            observations: this.crud.form.detail_register.check.observations
          }
        }

        if (type !== 'cheque' && type !== 'ajustes varios') {
          arrItem.date = this.crud.form.detail_register.date;
        }

        this.crud.form.detail.push(arrItem)
        
        this.crud.form.detail_register.type = 'efectivo'
        this.crud.form.detail_register.amount = 0        
        this.crud.form.detail_register.date = moment().format('YYYY-MM-DD')
        this.crud.form.detail_register.nro_certificate = ''        
        this.modal.check.active = false
        this.clearCheck()
        this.clearDetailAttachment()
      },      
      deleteItem (index) {
        this.crud.form.detail.splice(index, 1)
      },
      editItem (item, index) {        
        this.crud.form.detail_register.type = item.type
        this.crud.form.detail_register.amount = item.amount
        this.crud.form.detail_register.date = item.date
        this.crud.form.detail_register.nro_certificate = item.nro_certificate
        
        this.crud.form.detail_register.check.type = item.check.type
        this.crud.form.detail_register.check.bank = item.check.bank      
        this.crud.form.detail_register.check.number = item.check.number            
        this.crud.form.detail_register.check.observations = item.check.observations
        this.crud.form.detail_register.check.cuit = item.check.cuit      
        this.crud.form.detail_register.check.date_movement = item.check.date_movement        

        this.crud.form.detail_register.attachment = item.attachment || ''
        this.crud.form.detail_register.attachment_name = item.attachment_name || this.extractFileName(item.attachment)
        this.crud.form.detail_register.attachment_file = null
        if (this.$refs.detailAttachmentInput) {
          this.$refs.detailAttachmentInput.reset()
        }

        if (item.type=='cheque') {
          this.modal.check.active = true
        }

        this.crud.form.detail.splice(index, 1)
      },
      onDetailAttachmentInput(file) {
        const selectedFile = Array.isArray(file) ? file[0] : file

        if (!selectedFile) {
          this.clearDetailAttachment()
          return
        }

        this.crud.form.detail_register.attachment_file = selectedFile
        this.crud.form.detail_register.attachment_name = selectedFile.name
        this.crud.form.detail_register.attachment = ''
      },
      fileToBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = e => resolve(e.target.result)
          reader.onerror = err => reject(err)
          reader.readAsDataURL(file)
        })
      },
      clearDetailAttachment () {
        this.crud.form.detail_register.attachment = ''
        this.crud.form.detail_register.attachment_name = ''
        this.crud.form.detail_register.attachment_file = null
        if (this.$refs.detailAttachmentInput) {
          this.$refs.detailAttachmentInput.reset()
        }
      },
      clearAttachmentFromDetail (index) {
        if (this.crud.form.detail[index]) {
          this.$set(this.crud.form.detail[index], 'attachment', '')
          this.$set(this.crud.form.detail[index], 'attachment_name', '')
        }
      },
      isAnticipoVoucher (index) {
        const voucher = this.arr.select.vouchersPending[index] || {};
        const source = `${voucher.text || ''} ${voucher.type || ''}`.trim();
        return /^ANTICIPO\b/i.test(source);
      },
      isNotaCreditoVoucher (index) {
        const voucher = this.arr.select.vouchersPending[index] || {};
        const source = `${voucher.text || ''} ${voucher.type || ''}`.trim();
        return /\bNC\b/i.test(source) || /^NOTA\s+DE\s+CR[EÉ]D/i.test(source);
      },
      isStoredAttachment (value) {
        return typeof value === 'string' && value !== '' && !value.startsWith('data:')
      },
      getAttachmentUrl (value) {
        if (!this.isStoredAttachment(value)) {
          return null
        }

        if (value.startsWith('http')) {
          return value
        }

        if (value.startsWith('//')) {
          return `${window.location.protocol}${value}`
        }

        if (value.startsWith('/')) {
          return `${window.location.origin}${value}`
        }

        return `${window.location.origin}/${value.replace(/^\//, '')}`
      },
      extractFileName (value) {
        if (!value || typeof value !== 'string' || value.startsWith('data:')) {
          return ''
        }

        const parts = value.split('/')
        return parts.length ? parts[parts.length - 1] : value
      },
      openCheck () {
        this.modal.check.active = true
        this.modal.check.title = "Datos del cheque"
      },
      checkOk () {
        if (  this.crud.form.detail_register.check.type == '' ||
              this.crud.form.detail_register.check.bank == '' ||
              this.crud.form.detail_register.check.number == '' ||
              this.crud.form.detail_register.check.cuit == '' ||
              this.crud.form.detail_register.check.date_movement == '') {
          return false
        } else {
          return true
        } 
      },
      clearCheck () {
        this.crud.form.detail_register.check.type = ''
        this.crud.form.detail_register.check.bank = ''      
        this.crud.form.detail_register.check.number = ''      
        this.crud.form.detail_register.check.observations = ''
        this.crud.form.detail_register.check.cuit = ''        
        this.crud.form.detail_register.check.date_movement = ''        
      },
      verifyBCRA() {                
        let routeData = this.$router.resolve({name: 'BCRAStaffQuery'});
        window.open(routeData.href, '_blank');        
      },      

      // ABM MAIN
      add() {
        this.crud.form.id = 0
        this.crud.form.date = moment().format('YYYY-MM-DD')
        this.crud.form.observations = ''
        this.crud.form.staff_id = Helper.getStaffId()
        this.crud.form.sellers_id = 0
        this.crud.form.customers_id = 0
        this.crud.form.customers = null
        this.crud.form.read = false
        this.crud.form.informed = false
        this.crud.form.detail = []
        this.crud.form.vouchers = []
        this.crud.form.voucher_type = null
        this.crud.form.discount1 = 0
        this.crud.form.discount2 = 0
        this.crud.form.discount3 = 0
        this.crud.form.discount4 = 0
        this.arr.select.vouchersPending = []
        this.crud.formPending = []
        this.total.vouchersBalancePending = 0
        this.clearDetailAttachment()

        this.modal.form.title = "Nuevo Reporte"
        this.modal.form.active = true
      },      
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.customers = item.customer

        this.$bvModal.msgBoxConfirm('¿Desea borrar el item (' + this.crud.form.id + ') realizado al cliente ('+ this.crud.form.customers.name + ')?', {
          title: 'Borrar Reporte',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminar(this.crud.form.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()
              this.filterReport()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },      
      save() {
        this.$bvModal.msgBoxConfirm('¿Desea continuar con la operación?', {
          title: 'Guardar Reporte',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'Aceptar',
          cancelVariant: 'outline-dark',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'black',
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();            


            this.crud.form.amount_items = this.totalPayment
            this.crud.form.amount_vouchers = this.totalVouchers

            // Armar array de comprobantes seleccionados
            this.crud.form.vouchers = this.crud.formPending
              .map((item, index) => {
                if (!item.check) return null;

                const comprobante = this.arr.select.vouchersPending[index] || {};

                // Clonamos los detalles con todos los descuentos
                const details = (item.detail || []).map(d => ({
                  id: d.id,
                  description: d.description,
                  quantity: d.quantity,
                  amount_unit: d.amount_unit,
                  discount1: d.discount1,
                  discount2: d.discount2,
                  discount3: d.discount3,
                  discount4: d.discount4,
                  total: d.amount // o recalculado si quieres
                }));

                return {
                  id: item.id,
                  discount1: item.discount1,
                  discount2: item.discount2,
                  discount3: item.discount3,
                  discount4: item.discount4,
                  amount: item.amount, // monto total del voucher
                  date: comprobante.date || null,
                  vouchers: comprobante.text || '',
                  details: details // <-- agregamos el array de detalles con sus descuentos
                };
              })
              .filter(item => item !== null);

            this.crud.form.type_operation = this.crud.form.voucher_type;

            this.clearDetailAttachment()

            var result = serviceAPI.agregar(this.crud.form);
            
            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.filterReport()
              this.$awn.success("Datos guardados con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })            
      },

      showDetailVoucher(item, index) {                
        this.modal.detailVoucher.index = index
        this.modal.detailVoucher.title = "Detalle Comprobante: " + item.text        
        this.modal.detailVoucher.active = true        

        const voucher = this.crud.formPending[index];

        // Solo inicializar descuentos si aún no se hizo
        if (!voucher._detailInitialized) {
          voucher.detail.forEach(i => {
            i.discount1 = voucher.discount1
            i.discount2 = voucher.discount2
            i.discount3 = voucher.discount3
            i.discount4 = voucher.discount4
          });
          voucher._detailInitialized = true; // Marcamos como inicializado
        }
      },

      closeDetailVoucher() {
        // Si querés procesar algo antes de cerrar, lo hacés acá
        this.modal.detailVoucher.active = false
      },

      // LISTADO
      loadCustomers (object) {        
        if(object){
          this.crud.form.customers = object
          this.crud.form.customers_id = object.id   
          this.crud.form.voucher_type = null
          this.crud.form.vouchers = []
          this.arr.select.vouchersPending = []
          this.crud.formPending = []
          this.crud.form.type_operation = ''
          this.total.vouchersBalancePending = 0
          this.clearDetailAttachment()
          this.getBalancePendingByCustomers(object)
        } else {
          this.crud.form.customers = null
          this.crud.form.customers_id = 0
          this.crud.form.voucher_type = null
          this.crud.form.vouchers = []
          this.arr.select.vouchersPending = []
          this.crud.formPending = []
          this.crud.form.type_operation = ''
          this.total.vouchersBalancePending = 0
          this.clearDetailAttachment()
          //this.getBalancePendingByCustomers(null)
        }
      }, 
      filterLoad() {
        this.filterLoadCustomers()
        this.filterLoadStaff()     
        this.filterLoadSellers()   
        this.filter.date_start = moment().subtract(7, 'days').format('YYYY-MM-DD') 
        this.filter.date_end = moment().format('YYYY-MM-DD') 
        this.crud.form.detail_register.date = moment().format('YYYY-MM-DD') 

        this.restoreFilterStorage() 
      },
      filterLoadCustomers() {
        var result = serviceAPI.obtenerClientes()        
        result.then((response) => {
          var data = response.data    

          this.arr.filter.customers = []
          data.forEach(element => {            
            this.arr.filter.customers.push({ code: element.id, label: element.name })            
          });          
        })   
      },
      filterLoadStaff() {
        var result = serviceAPI.obtenerStaff()        
        result.then((response) => {
          var data = response.data    

          this.arr.filter.staff = []
          data.forEach(element => {                            
            if(!element.seller) {             
              this.arr.filter.staff.push({ code: element.id, label: element.name })    
            }                    
          });          
        })   
      },
      filterLoadSellers() {
        var result = serviceAPI.obtenerVendedores()        
        result.then((response) => {
          var data = response.data    

          this.arr.filter.sellers = []
          data.forEach(element => {                            
            this.arr.filter.sellers.push({ code: element.id, label: element.name })            
          });          
        })   
      },      
      filterReport(){
        this.table.isBusy = true  
   
        var result = serviceAPI.filtrarReport(this.filter, this.table.currentPage)        
        result.then((response) => {          
          var data = response.data
          this.table.tablePaginate = data

          this.table.items = data.data
          this.arr.export = []
          this.prepareExport(data.data)

          if(this.$refs.table) {                        
            this.$refs.table.$forceUpdate()
          }               

          this.table.isBusy = false
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });          
      }, 
      onVoucherCheckChange(index, checked) {
        this.$set(this.crud.formPending[index], 'check', checked)

        if (!checked) {
          // Si desmarcás, reseteo descuento y marca edición
          this.$set(this.crud.formPending[index], 'discount1', 0)
          this.$set(this.crud.formPending[index], 'discount2', 0)
          this.$set(this.crud.formPending[index], 'discount3', 0)
          this.$set(this.crud.formPending[index], 'discount4', 0)
          this.$set(this.crud.formPending[index], 'discountEdited', false)
        }

        // Podrías también actualizar el total o descuento general aquí si querés
      },
      prepareExport(data) {
        data.forEach(element => {
          var staffID = 0            
          var staffName = ''
          var sellersID = 0
          var sellersName = ''
          var customersID = 0
          var customersCode = ''
          var customersName = ''

          if(element.staff_id) {
            staffID = element.staff.id
            staffName = element.staff.name
          } else {
            sellersID = element.seller.id
            sellersName = element.seller.name
          }

          if(element.customers_id) {
            customersID = element.customer.id
            customersCode = element.customer.code
            customersName = element.customer.name            
          }

          this.arr.export.push({
            id: element.id,
            date: element.date,
            sellersID: sellersID,
            sellersName: sellersName,
            staffID: staffID,
            staffName: staffName,
            customersID: customersID,
            customersCode: customersCode,
            customersName: customersName,
            amountPayment: element.amounts_items,            
            observations: element.observations,
            canceled: element.canceled ? 'SI' : 'NO',
            reasonsCanceled: element.reasons_canceled || '',
            reference: '',
            type: '',
            amount: '',            
          })

          element.items.forEach(element1 => {
            this.arr.export.push({
              reference: 'Desgloce de Pago',              
              type: element1.type,
              amount: element1.amount
            })
          })

          element.vouchers.forEach(element2 => {
            this.arr.export.push({
              reference: 'Comprobantes',              
              type: element2.date + ' - ' + element2.vouchers,
              amount: element2.amount
            })
          })
          
        });
      },
      /** REDONDEO */
      round2(x) {
        return Math.round((Number(x) + Number.EPSILON) * 100) / 100;
      },

      /** RECALCULAR UN COMPROBANTE Y SU DETALLE */
      recalcRow(index) {
        const voucher = this.crud.formPending[index];
        if (!voucher || !voucher.detail) return;

        let totalVoucherDiscount = 0;
        let totalVoucherNet = 0;

        voucher.detail.forEach((item, idx) => {
          const subtotal = this.round2(Number(item.amount || 0));
          let restante = subtotal;
          let totalItemDiscount = 0;

          // Aplicar descuentos escalonados sobre el subtotal
          for (let n = 1; n <= 4; n++) {
            const p = Math.max(0, Math.min(100, Number(item[`discount${n}`] || 0)));
            const descN = this.round2(restante * (p / 100));
            restante = this.round2(restante - descN);
            totalItemDiscount = this.round2(totalItemDiscount + descN);
          }

          totalVoucherDiscount += totalItemDiscount;
          totalVoucherNet += restante;

          // Guardar resultados por ítem si querés mostrarlos
          item.amount_discount = totalItemDiscount;
          item.net = restante;
        });

        voucher.amount_discount = this.round2(totalVoucherDiscount);
        voucher.net = this.round2(totalVoucherNet);
      },

      /** CUANDO CAMBIO DESCUENTO GENERAL */
      onGeneralDiscountChange(num) {
        const value = this.crud.form[`discount${num}`] || 0;

        this.crud.formPending.forEach((voucher, i) => {
            if (!voucher.check) return;

            // Si el comprobante es un anticipo o nota de crédito, salta esta iteración
            const isAnticipo = this.isAnticipoVoucher(i) || this.isNotaCreditoVoucher(i);
            if (isAnticipo) {
                return;
            }

            // Si NO fue modificado manualmente a nivel comprobante
            if (!voucher[`manualDiscount${num}`]) {
                voucher[`discount${num}`] = value;

                // Propagar a detalle si no fue modificado manualmente
                voucher.detail.forEach((item) => {
                    if (!item[`manualDiscount${num}`]) {
                        item[`discount${num}`] = value;
                    }
                });

                this.recalcRow(i);
            }
        });
      },

      /** CUANDO CAMBIO DESCUENTO DE COMPROBANTE */
      onRowDiscountChange(index, n) {
        const voucher = this.crud.formPending[index];
        if (!voucher) return;

        this.$set(voucher, `manualDiscount${n}`, true);

        // Propagar a detalle si no fue manual
        voucher.detail.forEach((item) => {
          if (!item[`manualDiscount${n}`]) {
            item[`discount${n}`] = voucher[`discount${n}`];
          }
        });

        this.recalcRow(index);
      },

      /** CUANDO CAMBIO DESCUENTO EN DETALLE */
      onDetailDiscountChange(voucherIndex, detailIndex, n) {
        var voucher = this.crud.formPending[voucherIndex];
        var item = voucher && voucher.detail ? voucher.detail[detailIndex] : undefined;
        if (!item) return;

        this.$set(item, `manualDiscount${n}`, true);
        this.recalcRow(voucherIndex);
      },

      validateAnticipoAmount(index, originalAmount) {
        const newAmount = this.crud.formPending[index].amount;
        const absOriginalAmount = Math.abs(originalAmount);

        // Si el valor ingresado es menor a 0.1 o mayor al valor absoluto original,
        // lo ajustamos al límite más cercano.
        if (newAmount > absOriginalAmount) {
            this.crud.formPending[index].amount = absOriginalAmount;
            this.$awn.warning('El importe no puede ser mayor que el valor original.');
        } else if (newAmount < 0.1) {
            this.crud.formPending[index].amount = 0.1;
            this.$awn.warning('El importe no puede ser menor que 0.1.');
        }

        // Finalmente, aseguramos que el valor en el formulario sea negativo para los cálculos
        this.crud.formPending[index].amount = -Math.abs(this.crud.formPending[index].amount);
      },

      // SUBMENU
      checkRead(item) {
        let loader = this.$loading.show();     
        
        this.crud.form.id = item.id
        this.crud.form.date = item.date 
        this.crud.form.observations = item.observations
        this.crud.form.staff_id = item.staff_id
        this.crud.form.sellers_id = item.sellers_id
        this.crud.form.customers_id = item.customers_id
        this.crud.form.customers = item.customer
        this.crud.form.read = true
        this.crud.form.informed = item.informed
        
        var result = serviceAPI.editar(this.crud.form);
      
        result.then((response) => {          
          loader.hide()
          this.filterReport()
          this.$awn.success("Reporte marcado como Leido");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })        
      },
      checkNotRead(item) {
        let loader = this.$loading.show();     
        
        this.crud.form.id = item.id
        this.crud.form.date = item.date 
        this.crud.form.observations = item.observations
        this.crud.form.staff_id = item.staff_id
        this.crud.form.sellers_id = item.sellers_id
        this.crud.form.customers_id = item.customers_id
        this.crud.form.customers = item.customer
        this.crud.form.read = false
        this.crud.form.informed = item.informed
        
        var result = serviceAPI.editar(this.crud.form);
      
        result.then((response) => {          
          loader.hide()
          this.filterReport()
          this.$awn.success("Reporte marcado como No Leido");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })        
      },
      checkInformed(item) {
        let loader = this.$loading.show();     
        
        this.crud.form.id = item.id
        this.crud.form.date = item.date 
        this.crud.form.observations = item.observations
        this.crud.form.staff_id = item.staff_id
        this.crud.form.sellers_id = item.sellers_id
        this.crud.form.customers_id = item.customers_id
        this.crud.form.customers = item.customer
        this.crud.form.informed = true
        this.crud.form.read = item.read
        
        var result = serviceAPI.editar(this.crud.form);
      
        result.then((response) => {          
          loader.hide()
          this.filterReport()
          this.$awn.success("Reporte marcado como pasado");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })        
      },
      checkNotInformed(item) {
        let loader = this.$loading.show();     
        
        this.crud.form.id = item.id
        this.crud.form.date = item.date 
        this.crud.form.observations = item.observations
        this.crud.form.staff_id = item.staff_id
        this.crud.form.sellers_id = item.sellers_id
        this.crud.form.customers_id = item.customers_id
        this.crud.form.customers = item.customer
        this.crud.form.informed = false
        this.crud.form.read = item.read
        
        var result = serviceAPI.editar(this.crud.form);
      
        result.then((response) => {          
          loader.hide()
          this.filterReport()
          this.$awn.success("Reporte marcado como No Pasado");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })        
      },

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_report_payment', JSON.stringify(this.filter))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_report_payment')) {
          this.filter = JSON.parse(Storage.getValue('filter_report_payment'))
        }         
      },

      irDetail(item){
        this.saveFilterStorage()
        this.$router.push({ name: 'ReportsPaymentStaffDetailReport', params: {reportID: item.id} })
      },
      sendPrinterOrder(item) {
        this.crud.print.key=Math.random()
        this.crud.print.id=item.id
      }
    }    
  }
</script>
<style>
  .report-payment-crud-icon {
    color: #000 !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    font-size: 18px;
  }
  .report-payment-check-read-table {
    cursor: pointer;
  }    
  .report-payment-label {
    margin-top: 0px;
    margin-left: 0px;
    margin-bottom: 37px;
    font-weight: bold;
    color: #000;
  }  
  .report-payment-button-add {
    background: green;
    color: white;
    position: relative;
    min-width: 20px;
    padding: 5px 0px;
    margin-top: 30px;
    height: 30px;
    line-height: 20px;
    width: 30px;
  }
  .report-payment-button-add i {
    font-size: 15px;
  }  
  .report-payment-total-size {
    font-size: 20px;
  }
  .reports-payment-row-canceled {
    background-color: #fdeaea !important;
  }
  .reports-payment-row-canceled td {
    background-color: #fdeaea !important;
  }
  .reports-payment-canceled-badge {
    font-size: 0.75rem;
  }
  .report-payment-diff-lack {
    color: red;
  }
  .report-payment-diff-surplus {
    color: green;
  }
  .report-payment-diff-just {
    color: blue;
  }
  .report-payment-popover-size {
    font-size: 14px;
  }
  .report-payment-popover-item-header {
    font-size: 14px !important;
    font-weight: 700 !important;   
    padding-right: 5px !important;      
  }  
  .report-payment-button-check {
    background: orange;
    color: white;
    position: relative;
    margin-left: 10px;
    min-width: 20px;
    padding: 5px 0px;
    margin-top: 30px;
    height: 30px;
    line-height: 20px;
    width: 30px;
  }
  .report-payment-button-check i {
    font-size: 15px;
  }  
  .report-payment-text-red {
    color: darkred;    
  }
  .report-payment-text-green {
    color: darkgreen;    
  }  
  .verify-credit-status {
    color: darkred !important;
    font-weight: bold;
    cursor: pointer;
  }
  .verify-credit-status:hover {
    text-decoration: underline !important; 
  }   
  .balance-pending {
    float: right;    
    font-weight: bold;    
  }
</style>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;    
  }  
</style>
